import {request} from '@umijs/max';

export async function findOne(params) {
  return request('/api/perEnterprise/findOne', {
    params,
  });
}

/**
 * 如果查询代理商 queryData:{enterpriseType:'AGENT'}
 * @param params
 * @returns {Promise<any>}
 */
export async function find(params) {
  return request('/api/perEnterprise/find', {
    params,
  });
}
export async function remove(params) {
  return request('/api/perEnterprise/delete', {
    method: 'POST',
    data: { ...params, method: 'delete' },
  });
}
export async function saveOrUpdate(params) {
  return request('/api/perEnterprise/saveOrUpdate', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}

export async function saveOrUpdateEnterpriseProfile(params) {
  return request('/api/perEnterprise/saveOrUpdateEnterpriseProfile', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}

export async function getEnterpriseProfile(params) {
  return request('/api/perEnterprise/getEnterpriseProfile', {
    params,
  });
}

/**
 * 启用企业 params:{enterpriseId:xxx}
 * @param params
 * @returns {Promise<any>}
 */
export async function enablePerEnterprise(params) {
  return request('/api/perEnterprise/enablePerEnterprise', {
    params,
  });
}

/**
 * 禁用企业 params:{enterpriseId:xxx}
 * @param params
 * @returns {Promise<any>}
 */
export async function disablePerEnterprise(params) {
  return request('/api/perEnterprise/disablePerEnterprise', {
    params,
  });
}

/**
 * 重置密码
 * params:{id:xxx,password:xxxx} password 不传递则后台默认为123456
 * @param params
 * @returns {Promise<any>}
 */
export async function resetPassword(params) {
  return request('/api/resetPassword', {
    params,
  });
}

/**
 * 获取监管部门[含销售跟进人]
 *  如果选择上级代理商，则传递上级代理商ID，params:{enterpriseId:xxx}；如果不选，则不传递
 * @param params
 * @returns {Promise<any>}
 */
export async function findPerDeptIncludePerUsers(params) {
  return request('/api/perEnterprise/findPerDeptIncludePerUsers', {
    params,
  });
}

/**
 * 更新代理商运维单位ID
 * {id:代理商ID,operationEnterpriseId:运维单位Id}
 * @param params
 * @returns {Promise<any>}
 */
export async function updateOperationIdForAgent(params) {
  return request('/api/perEnterprise/updateOperationIdForAgent', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}




export async function createAccountForEnterprise(params) {
  return request('/api/v2/perEnterprise/createAccountForEnterprise', {
    method: 'POST',
    data: params,
  });
}

export async function getAccountForEnterprise(params) {
  return request('/api/v2/perEnterprise/getAccountForEnterprise', {
    params,
  });
}

export async function destroyEnv(params) {
  return request('/api/v2/destroyEnv', {
    method: 'POST',
    data: params,
  });
}

export async function upgradeVersion(params) {
  return request('/api/v2/upgradeVersion', {
    method: 'POST',
    data: params,
  });
}

export async function manualStopEnterpriseUsage(params) {
  return request('/api/enterpriseUsage/manualStop', {
    method: 'POST',
    params,
  });
}

/**
 * 查询指定企业 MES 数据总览统计卡片，用于平台端企业数据监测。
 * @param params
 * @returns {Promise<any>}
 */
export async function queryEnterpriseDataOverviewStatCards(params) {
  return request('/api/v2/perEnterprise/dataOverview/statCards', {
    params,
  });
}
